
import BackendResourceDataTable from '@/components/BackendResourceDataTable.vue';
import FiltroPorTabela from '@/components/FiltrosPorTabela.vue';
import LeadCardComponent from '@/components/LeadCardComponent.vue';
import { leadStore, leadTimeStore, mainStore, userActionStore, userToolStore } from '@/store';
import { preventClipboardCopy } from '@/utils/utils';
import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';
import draggable from 'vuedraggable';

@Component({
  components: {
    draggable,
    LeadCardComponent,
    FiltroPorTabela,
    BackendResourceDataTable,
  },
})
export default class LeadList extends Vue {
  public nome_fantasia = '';
  public razao_social = '';
  selectedRows = [];
  public filtros = {};

  get GerarExcelExpansao() {
    return userActionStore.GerarExcelExpansao;
  }

  get populacaoFilter() {
    return _.pickBy(this.selectedPopulacao, (_, k) => k !== 'text');
  }
  selectedPopulacao: any = {};
  populacaoOptions = [
    {
      text: 'Até 50 mil habiltantes',
      min_populacao: 0,
      max_populacao: 50000,
    },
    {
      text: 'De 50 a 100 mil habiltantes',
      min_populacao: 50000,
      max_populacao: 100000,
    },
    {
      text: 'De 100 a 200 mil habiltantes',
      min_populacao: 100000,
      max_populacao: 200000,
    },
    {
      text: 'De 200 a 500 mil habiltantes',
      min_populacao: 200000,
      max_populacao: 500000,
    },
    {
      text: 'De 500 a 1 milhão de habiltantes',
      min_populacao: 500000,
      max_populacao: 1000000,
    },
    {
      text: 'De 1 a 2 milhões de habiltantes',
      min_populacao: 1000000,
      max_populacao: 2000000,
    },
    {
      text: 'Mais de 2 milhões de habiltantes',
      min_populacao: 2000000,
      max_populacao: 10000000,
    },
  ];

  get userProfile() {
    return mainStore.userProfile;
  }

  async reloadTable() {
    const table: any = this.$refs.Table;
    if (table) {
      await table.load();
    }
  }

  public headers = [{ text: 'Ações', value: 'actions', align: 'center' }];

  public movidoParaEtapa = { id: -1 };

  public movidoParaVendedor = { id: -1 };

  public loading = false;

  public showFiltroPorTabela() {
    let form: any = this.$refs.filtroPorTabela;
    form.show('lead');
  }

  public get qualificado() {
    return [
      { id: 0, name: 'Todos' },
      { id: 1, name: 'Sim' },
      { id: 2, name: 'Não' },
    ];
  }

  public get arquivado() {
    return [
      { id: 0, name: 'Todos' },
      { id: 1, name: 'Sim' },
      { id: 2, name: 'Não' },
    ];
  }

  public routeEdit(id: string) {
    const routeData = this.$router.resolve({
      name: 'main-lead-edit',
      params: { id },
    });
    window.open(routeData.href, '_blank');
  }

  get leadTimes() {
    return leadTimeStore.leadTimes;
  }

  get userTool() {
    return userToolStore.currentUserTools.find((t) => t.tool_id === 10);
  }

  get vendedorOptions() {
    const vendedores = this.leadTimes.map((lt) => {
      return {
        id: lt.vendedor_id,
        name: lt['vend_full_name'],
      };
    });

    let uniqueVendedores: any[] = [];
    vendedores.forEach((v) => {
      if (!uniqueVendedores.some((v2) => v2.id === v.id)) {
        uniqueVendedores.push(v);
      }
    });

    uniqueVendedores.unshift(
      {
        id: -1,
        name: 'Não alterar vendedor',
      },
      {
        id: 0,
        name: 'Vendedores aleatórios',
      }
    );

    return uniqueVendedores;
  }

  clipboardCopyProtection: any = null;

  async unmounted() {
    if (this.clipboardCopyProtection) {
      this.clipboardCopyProtection();
    }
  }

  public async mounted() {
    this.clipboardCopyProtection = preventClipboardCopy(this.$el as HTMLElement);

    await leadTimeStore.getLeadTimes();
    await userToolStore.getToolsByUserId(this.userProfile!.id!);
  }

  get currentUser() {
    return mainStore.userProfile!;
  }

  get allowMove() {
    if (this.currentUser.franchising_id === 1) {
      return this.currentUser.is_superuser || this.HabilitarMoverLeadsVendedor;
    } else {
      return this.userProfile!.role?.level! < 3 || this.HabilitarMoverLeadsVendedor;
    }
  }

  get HabilitarMoverLeadsVendedor() {
    return userActionStore.HabilitarMoverLeadsVendedor;
  }

  public async moverPara() {
    this.$swal({
      title: 'Confirma a movimentação dos leads?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        let leads_updated = await leadStore.updateEtapaAtualLead({
          etapa_id: this.movidoParaEtapa.id,
          vendedor_id: this.movidoParaVendedor.id,
          leads: this.selectedRows,
        });

        leads_updated = Object.values(leads_updated);

        const errorLeads = leads_updated.filter((item) => item.hasOwnProperty('error'));
        const successLeads = leads_updated.filter((item) => !item.hasOwnProperty('error'));

        const successLeadsIds = _.map(successLeads, 'lead');
        this.selectedRows = _.filter(this.selectedRows, (r) => {
          return !_.includes(successLeadsIds, r.id);
        });

        if (errorLeads.length == 0 && successLeads.length > 0) {
          let html: any = Object.values(successLeads).map((value) => {
            // @ts-ignore
            return `<br/> Lead: ${value.lead} - Nome ${value.name}<br/>Vendedor: ${value.vendedor}<br/>`;
          });
          this.$swal({
            title: 'Leads atualizados',
            icon: 'success',
            html: html,
          });
        } else if (errorLeads.length > 0 && successLeads.length > 0) {
          let html = '<u>Leads atualizados:</u>';
          html += Object.values(successLeads).map((value) => {
            // @ts-ignore
            return `<br/> Lead: ${value.lead} - Nome ${value.name}<br/>Vendedor: ${value.vendedor}<br/>`;
          });
          html += '<br/><u>Leads não atualizados:</u>';
          const lastLeadUpdated = Object.keys(errorLeads)[Object.keys(errorLeads).length - 1];
          for (const lead of Object.keys(errorLeads)) {
            if (lead != lastLeadUpdated) {
              html += `<br/>Nome: ${errorLeads[lead]['name']}`;
            } else {
              html += `<br/>Nome: ${errorLeads[lead]['name']}<br/>${errorLeads[lead]['error']}`;
            }
          }
          this.$swal({
            title: 'Um ou mais leads não foram movidos',
            icon: 'warning',
            html: html,
          });
        } else if (errorLeads.length > 0 && successLeads.length == 0) {
          const lastLeadUpdated = Object.keys(errorLeads)[Object.keys(errorLeads).length - 1];
          //@ts-ignore
          let html = '';
          for (const lead of Object.keys(errorLeads)) {
            if (lead != lastLeadUpdated) {
              html += `<br/>Nome: ${errorLeads[lead]['name']}`;
            } else {
              html += `<br/>Nome: ${errorLeads[lead]['name']}<br/>${errorLeads[lead]['error']}`;
            }
          }
          this.$swal({
            title: 'Ocorreu um erro ao mover o lead',
            icon: 'error',
            html: html,
          });
        }
      }
    });
  }

  public async exluirLeads() {
    // this.loading = true;
    //const leadsToRemove = this.selectedRows.filter((l) => l["selected"]);
    //await leadStore.removeLeads(leadsToRemove);
    // this.loading = false;
  }

  public async handleInativarLeads() {
    let ids = '';
    this.selectedRows.map((item) => {
      ids += item.id + ',';
    });
    ids = ids.slice(0, -1);

    this.$swal({
      title: 'Confirma inativar o(s) Lead(s)?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.loading = true;
        let res = await leadStore.inativaLeads(ids);
        if (res) {
          this.$swal.fire('Lead(s)', 'Inativados com sucesso!', 'success');
          let response = setTimeout(async () => {
            this.selectedRows = [];
            this.reloadTable();
          }, 2000);
        } else {
          this.$swal.fire('Falha ao inativar o(s) lead(s).', 'Tente novamente mais tarde!', 'error');
        }
      }
      this.loading = false;
    });
  }
}
